import {DetailsWrapper} from "../../components/details-wrapper/details-wrapper";
import React, {useEffect, useMemo, useState} from "react";
import {Form, Formik} from "formik";
import {Grid} from "@material-ui/core";
import {StyledButton} from "../../components/ui-base/button";
import {StyledSelect} from "../../components/form/select";
import {PublisherService} from "../../services/publisher.service";
import {showSnackError, showSnackSuccess, toggleLoader} from "../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {AuthService} from "../../services/auth.service";
import {logged} from "../../store/auth/auth-slice";
import {IProfileData, PublisherCreateProfile} from "../../components/publisher/create-profile/create-profile";
import {StyledInput} from "../../components/form/input";
import {useTranslation} from "react-i18next";
import {CountryAutocomplete} from "../../components/form/country-autocomplete";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import * as Yup from "yup";
import {BoxWrapper} from "../../components/box-wrapper/box-wrapper";
import {CreatePublisherError} from "../../components/publisher/create-publisher-error";

const EditPublisherSchema = Yup.object().shape({
    country: Yup.mixed().required(),
    publisherType: Yup.boolean(),
    agencyType: Yup.boolean()
    // agencyType: Yup.boolean().when('publisherType', (publisherType) => {
    // 	if (!publisherType) {
    // 		return Yup.boolean().required();
    // 	}
    // }),
    // publisherType: Yup.boolean().when('agencyType', (agencyType) => {
    // 	if (!agencyType) {
    // 		return Yup.boolean().required();
    // 	}
    // })
}).test(
    'accountTypeTest',
    null,
    (obj) => {
        if (obj.publisherType || obj.agencyType) {
            return true;
        }

        return new Yup.ValidationError(
            'Please check one checkbox',
            null,
            'publisherType'
        );
    }
);

const PublisherEditProfileFirstTime = () => {
    const [publisherNames, setPublisherNames] = useState([]);
    const [profileData, setProfileData] = useState<IProfileData>(null);
    const [extendErrorDetails, setExtendErrorDetails] = useState<boolean>(false);
    const [openErrorDialog, setOpenErrorDialog] = React.useState<boolean>(false);
    const [errorDialogType, setErrorDialogType] = React.useState<1 | 2>(1);
    const dispatch = useDispatch();
    const history = useHistory();
    const {t} = useTranslation(['publisher', 'common']);

    const formInitialValues = useMemo(() => ({
        publisherName: '',
        name: '',
        country: null,
        publisherType: true,
        agencyType: false
    }), []);

    useEffect(() => {
        const loadPublisherNames = async () => {
            dispatch(toggleLoader(true));

            const tmp = await PublisherService.getPublisherNames();
            setPublisherNames([{
                id: null,
                name: t('editProfileFirstTime.createNew'),
                details: {
                    country: null}
            }, ...tmp]);

            dispatch(toggleLoader(false));
        }

        loadPublisherNames();
    }, [dispatch, t]);

    const formSubmit = async (values) => {
        let publisherName = null;

        if (values.publisherName && values.publisherName !== t('editProfileFirstTime.createNew')) {
            dispatch(toggleLoader(true));
            publisherName = publisherNames.find((name) => name.name === values.publisherName);


            const res = await PublisherService.createFirstTimeProfile(
                values.publisherType,
                values.agencyType,
                null,
                publisherName,
                values.country
            );

            if (res.status) {
                AuthService.authMe().then((res) => {
                    if (res) {
                        dispatch(logged(res));

                        dispatch(showSnackSuccess(t('editProfileFirstTime.accountConnectedToPublisher')));
                        history.push('/publisher/edit-profile');
                    }
                });
            } else {
                if ((res.data as any)?.code === 'publisher_already_managed' || (res.data as any)?.code === 'publisher_inactive') {
                    setErrorDialogType(2);
                    setOpenErrorDialog(true);
                }

                if ((res.data as any)?.code === 'publisher_has_already_linked_user') {
                    setErrorDialogType(1);
                    setOpenErrorDialog(true);
                }
            }

            dispatch(toggleLoader(false));
        } else if (values.publisherName === t('editProfileFirstTime.createNew') || values.country.iso !== 'PL') {
            dispatch(toggleLoader(true));

            if (profileData) {
                if (profileData.valid) {
                    dispatch(toggleLoader(true));

                    const res = await PublisherService.createFirstTimeProfile(
                        values.publisherType,
                        values.agencyType,
                        values.name,
                        null,
                        values.country
                    );

                    if (res.status) {
                        const res2 = await PublisherService.updateProfileData(
                            res.data.id,
                            profileData
                        );

                        if (res2) {
                            AuthService.authMe().then((res3) => {
                                if (res3) {
                                    dispatch(logged(res3));

                                    dispatch(showSnackSuccess(t('editProfileFirstTime.accountConnectedToPublisher')));
                                    history.push('/publisher/edit-profile');
                                }
                            });
                        }
                    }
                } else {
                    setExtendErrorDetails(true);
                    dispatch(showSnackError(profileData.errorText));
                    dispatch(toggleLoader(false));
                }
            } else {
                dispatch(showSnackError(t('editProfileFirstTime.validError')));
                dispatch(toggleLoader(false));
            }
        }
    }


    return (
        <DetailsWrapper description={t('editProfileFirstTime.pageDesc')}>
            <Formik
                initialValues={formInitialValues}
                validationSchema={EditPublisherSchema}
                onSubmit={(values) => {
                    formSubmit(values);
                }}
            >
                {({values, touched, errors, handleChange, handleBlur, isValid, setFieldValue}) => (
                    <Form>
                        <Grid container direction="row" justifyContent="flex-end" spacing={2}>
                            <Grid item>
                                <StyledButton type="submit">
                                    {t('common:save')}
                                </StyledButton>
                            </Grid>
                        </Grid>

                        {/*<StyledAccountType*/}
                        {/*    className={(errors.publisherType && touched.publisherType) ? 'error' : ''}>{t('editProfileFirstTime.accountType')}*</StyledAccountType>*/}
                        {/*<Grid container direction="row" style={{marginBottom: '1rem'}}>*/}
                        {/*    <Grid item>*/}
                        {/*        <StyledCheckbox*/}
                        {/*            id={"publisherType"}*/}
                        {/*            name={"publisherType"}*/}
                        {/*            onChange={handleChange}*/}
                        {/*            value={values.publisherType}*/}
                        {/*            label={t('common:publisher')}*/}
                        {/*        />*/}
                        {/*    </Grid>*/}

                        {/*    <Grid item>*/}
                        {/*        <StyledCheckbox*/}
                        {/*            id={"agencyType"}*/}
                        {/*            name={"agencyType"}*/}
                        {/*            onChange={handleChange}*/}
                        {/*            value={values.agencyType}*/}
                        {/*            label={t('common:agency')}*/}
                        {/*        />*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}

                        <Grid item style={{marginBottom: '1rem'}}>
                            <CountryAutocomplete
                                values={values}
                                multiple={false}
                                setFieldValue={setFieldValue}
                                fieldName={'country'}
                                label={t('editProfileFirstTime.pickCountry') + '*'}
                                error={!!(errors.country && touched.country)}
                            />
                        </Grid>

                        {values.country && values.country.iso === 'PL' &&
                            <Grid item style={{marginBottom: '1rem'}}>
                                <StyledSelect
                                    id={'publisherName'}
                                    label={t('editProfileFirstTime.pickPublisher')}
                                    onChange={handleChange}
                                    value={values.publisherName}
                                    options={publisherNames.filter((name) => name.details.country === values.country.iso || name.name === t('editProfileFirstTime.createNew')).map((name) => name.name)}
                                />
                            </Grid>
                        }

                        {
                            (
                                values.country &&
                                (
                                    values.publisherName === t('editProfileFirstTime.createNew') ||
                                    values.country.iso !== 'PL'
                                )
                            ) &&
                            <Grid item style={{marginBottom: '1rem'}}>
                                <StyledInput
                                    id="name"
                                    label={t('editProfileFirstTime.name') + "*"}
                                    onChange={handleChange}
                                    value={values.name}
                                    error={errors.name && touched.name}
                                />
                            </Grid>
                        }

                        {
                            (
                                values.country &&
                                (
                                    values.publisherName === t('editProfileFirstTime.createNew') ||
                                    values.country.iso !== 'PL'
                                )
                            ) &&
                            <BoxWrapper title={t('editProfile.form.categories') + "*"} style={{marginTop: '2rem'}}>
                                <StyledDesc>
                                    {t('editProfile.form.categoriesDesc')}
                                </StyledDesc>
                                <PublisherCreateProfile
                                    handleProfileData={(data: IProfileData) => {
                                        setProfileData(data)
                                    }}
                                    extendErrorDetails={extendErrorDetails}
                                />
                            </BoxWrapper>
                        }
                    </Form>
                )}
            </Formik>

            <CreatePublisherError
                open={openErrorDialog}
                onClose={async (value: any) => {
                    AuthService.authMe().then((res) => {
                        if (res) {
                            dispatch(logged(res));
                            history.push('/dashboard');
                        }

                        setOpenErrorDialog(false);
                    });
                }}
                type={errorDialogType}
            />
        </DetailsWrapper>
    )
}

const StyledAccountType = styled('p')`
  color: ${Colors.violet};
  font-weight: 500;
  font-size: 0.9rem;

  &.error {
    color: #f44336;
  }
`;

const StyledDesc = styled('p')`
  color: ${Colors.grayText};
  font-size: 0.9rem;
  margin-top: -1rem;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
`;

export default PublisherEditProfileFirstTime;
